/**
 * Whether a text placement is switched on in the builder.
 *
 * A product can define several default placements for one text (a number on
 * the back AND on the front); the customer turns placements off in the
 * customizer, which the builder persists as `selected: false` on the item and
 * skips at render time (`src/lib/productTextRenderability.ts`,
 * `isTextItemVisible`). Same rule here, or the production file prints a number
 * the customer removed.
 */
export function isTextPlacementOn(item: { selected?: unknown } | null | undefined): boolean {
  return !isExplicitlyOff(item?.selected);
}

/**
 * Whether a text placement's outline is switched on. The builder strokes only
 * with `outline_enabled` on (`useTexts.ts`); an outline width/colour left on an
 * item whose outline was switched off must not print. Orders saved before the
 * flag existed carry no `outline_enabled` and keep their outline.
 */
export function isTextOutlineOn(item: { outline_enabled?: unknown } | null | undefined): boolean {
  return !isExplicitlyOff(item?.outline_enabled);
}

function isExplicitlyOff(v: unknown): boolean {
  return v === false || v === 0 || v === '0';
}
